import { CONTENT_TYPE_ID, NEDGLOBE_VIEWER } from '../../../constants';

export const mutations = {
    MOVE_FEEDBACK_ORDER(state, { from, to, contentTypeId }) {
        const startOrderNumber = contentTypeId === CONTENT_TYPE_ID.MEASUREMENT ? NEDGLOBE_VIEWER.userLayers.measurementsStartIndex : NEDGLOBE_VIEWER.userLayers.feedbacksStartIndex;
        const otherItems = state.feedbacks.filter(feedback => feedback.data.feedbackType.contentTypeId !== contentTypeId);
        const sortItems = state.feedbacks.filter(feedback => feedback.data.feedbackType.contentTypeId === contentTypeId);
        let items = sortItems.sort((a, b) => a.order - b.order);
        items.splice(to, 0, items.splice(from, 1)[0]);
        items = items.map((item, index) => ({ ...item, order: startOrderNumber + index }));
        state.feedbacks = [...items, ...otherItems];
    },
    ADD_FEEDBACK(state, { feedbackData, active, layerId }) {
        const startOrderNumber = feedbackData.feedbackType.contentTypeId === CONTENT_TYPE_ID.MEASUREMENT ?
            NEDGLOBE_VIEWER.userLayers.measurementsStartIndex : NEDGLOBE_VIEWER.userLayers.feedbacksStartIndex;
        const feedback = {
            id: feedbackData.id,
            name: feedbackData.name,
            active,
            data: feedbackData,
            layerId: layerId !== undefined ? layerId : null,
            order: startOrderNumber + feedbackData.order
        };
        const feedbacks = state.feedbacks.filter(_feedback => _feedback.id !== feedback.id);
        state.feedbacks = [...feedbacks, feedback];
    },
    CONNECT_LAYER_TO_FEEDBACK(state, { id, data }) {
        const feedback = { ...state.feedbacks.find((currentFeedback) => currentFeedback.id === id) };
        // TODO very confusing what datapoint from backend contains what information
        // fix with normalizing backend api
        // This caused bug 1138, fixed by getting feedbackFields from feedback.data (and not from data where feedbackFields are empty)
        feedback.data = {
            ...data,
            ...feedback.data,
            themeLayers: data.themeLayers,
            feedbackType: { ...data.feedbackType, feedbackFields: feedback.data.feedbackType.feedbackFields }
        };
        feedback.layerId = data.themeLayers[0].id;
        state.feedbacks = [
            ...state.feedbacks.filter((currentFeedback) => currentFeedback.id !== id),
            feedback
        ];
    },
    UPDATE_FEEDBACKFIELDS_DOMAIN(state, { id, fields }) {
        const feedback = { ...state.feedbacks.find((currentFeedback) => currentFeedback.id === id) };
        fields.forEach((field) => {
            const targetField = feedback.data.feedbackType.feedbackFields.find(
                (feedbackField) => feedbackField.name === field.name
            );
            if (targetField && targetField.domain.keyvalues.length !== field.domain.keyvalues.length) {
                targetField.domain.keyvalues = field.domain.keyvalues;
            }
        });
    },
    SET_IMPORT_FEEDBACK_CANCELLATION_TOKEN(state, token) {
        state.importFeedbackCancelToken = token;
    }
};
